import { render, staticRenderFns } from "./ImageSegmentationPreviewModal.vue?vue&type=template&id=1b62181b&scoped=true"
import script from "./ImageSegmentationPreviewModal.vue?vue&type=script&lang=js"
export * from "./ImageSegmentationPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ImageSegmentationPreviewModal.vue?vue&type=style&index=0&id=1b62181b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b62181b",
  null
  
)

export default component.exports